import { Box, Container, Stack, Typography } from '@mui/material';

export function About() {
  return (
    <Box
      component="section"
      id="about"
      sx={{
        backgroundColor: '#ebe5d6',
        py: { xs: 9, md: 13 },
      }}
    >
      <Container maxWidth="md">
        <Stack spacing={3} sx={{ textAlign: 'center', alignItems: 'center' }}>
          <Typography variant="overline" sx={{ color: 'primary.main' }}>
            About Logan
          </Typography>
          <Typography
            variant="h2"
            component="h2"
            sx={{
              color: 'primary.dark',
              fontSize: { xs: '2rem', md: '2.7rem' },
              maxWidth: 720,
            }}
          >
            A coach for leaders who want clarity and momentum.
          </Typography>
          <Typography
            variant="body1"
            sx={{ color: 'text.secondary', maxWidth: 640, fontSize: { xs: '1rem', md: '1.075rem' } }}
          >
            Logan White is the founder of Growth Focus Solutions, an executive coaching and
            leadership development practice dedicated to helping leaders and teams reach their full
            potential. He works one-on-one with executives and with leadership teams who want to
            move from stuck to stretched, from reactive to deliberate, from busy to effective.
          </Typography>
          <Typography
            variant="body1"
            sx={{ color: 'text.secondary', maxWidth: 640, fontSize: { xs: '1rem', md: '1.075rem' } }}
          >
            Trained at the Townsend Institute at Concordia University Irvine, Logan brings a
            grounded, deeply human approach to professional growth — the kind that lasts beyond a
            single conversation.
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
}
